import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';

interface PropsType {
    className?: string;
    onClick?: () => void;
}

const SvgElement = styled('svg', { label: 'SvgElement' })`
    height: auto;
`;

export const FaqIcon = observer('FaqIcon', ({ className, onClick }: PropsType): JSX.Element => {
    return (
        <SvgElement
            xmlns='http://www.w3.org/2000/svg'
            width='16'
            height='16'
            fill='none'
            viewBox='0 0 24 24'
            className={className}
            onClick={onClick}
        >
            <path
                fill='currentColor'
                fillRule='evenodd'
                d='M23 12c0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1s11 4.925 11 11M9.351 7.134q1-1 2.756-1 1.657 0 2.609.754.951.754.951 2.116 0 .87-.394 1.444-.393.574-1.148 1.231-.656.59-.968 1.025t-.312 1.042h-2.182q0-.657.189-1.149t.459-.812c.27-.32.413-.457.698-.73q.476-.444.705-.78.23-.337.23-.796c0-.667-.372-1-.116-1q-1.23 0-1.247 1.46l-2.248-.016q.017-1.79 1.017-2.79m3.363 8.236q.394.395.394 1.017c0 .622-.132.757-.394 1.025s-.602.402-1.017.402a1.34 1.34 0 0 1-1-.402 1.43 1.43 0 0 1-.393-1.025q0-.622.385-1.017a1.34 1.34 0 0 1 1.008-.394q.623 0 1.017.394'
                clipRule='evenodd'
            />
        </SvgElement>
    );
});
